import { Encoder, MGPOptional, Utils } from '@everyboard/lib';
import { Move } from '../../jscaip/Move';
import { PylosCoord } from './PylosCoord';
import { PylosFailure } from './PylosFailure';
export class PylosMoveFailure {
    static MUST_CAPTURE_MAXIMUM_TWO_PIECES = () => $localize `You must capture one or two pieces, not more.`;
}
export class PylosMove extends Move {
    startingCoord;
    landingCoord;
    firstCapture;
    secondCapture;
    static encoder = Encoder.tuple([PylosCoord.optionalEncoder, PylosCoord.coordEncoder, PylosCoord.optionalEncoder, PylosCoord.optionalEncoder], (move) => [move.startingCoord, move.landingCoord, move.firstCapture, move.secondCapture], (fields) => PylosMove.of(fields[0], fields[1], fields[2], fields[3]));
    static ofClimb(startingCoord, landingCoord, captures) {
        const startingCoordOpt = MGPOptional.of(startingCoord);
        const capturesOptionals = PylosMove.checkCaptures(captures);
        const newMove = new PylosMove(startingCoordOpt, landingCoord, capturesOptionals.firstCapture, capturesOptionals.secondCapture);
        Utils.assert(landingCoord.isHigherThan(startingCoord), PylosFailure.MUST_MOVE_UPWARD());
        return newMove;
    }
    static checkCaptures(captures) {
        let firstCapture = MGPOptional.empty();
        let secondCapture = MGPOptional.empty();
        if (captures.length > 0) {
            firstCapture = MGPOptional.of(captures[0]);
            if (captures.length > 1) {
                if (captures[1].equals(captures[0])) {
                    throw new Error('PylosMove: should not capture twice same piece.');
                }
                secondCapture = MGPOptional.of(captures[1]);
                if (captures[1].isHigherThan(captures[0])) {
                    firstCapture = MGPOptional.of(captures[1]);
                    secondCapture = MGPOptional.of(captures[0]);
                }
                if (captures.length > 2) {
                    throw new Error(PylosMoveFailure.MUST_CAPTURE_MAXIMUM_TWO_PIECES());
                }
            }
        }
        return { firstCapture, secondCapture };
    }
    static ofDrop(landingCoord, captures) {
        const startingCoord = MGPOptional.empty();
        const capturesOptionals = PylosMove.checkCaptures(captures);
        return new PylosMove(startingCoord, landingCoord, capturesOptionals.firstCapture, capturesOptionals.secondCapture);
    }
    static changeCapture(move, captures) {
        const capturesOptionals = PylosMove.checkCaptures(captures);
        return new PylosMove(move.startingCoord, move.landingCoord, capturesOptionals.firstCapture, capturesOptionals.secondCapture);
    }
    static of(startingCoord, landingCoord, firstCapture, secondCapture) {
        return new PylosMove(startingCoord, landingCoord, firstCapture, secondCapture);
    }
    constructor(startingCoord, landingCoord, firstCapture, secondCapture) {
        super();
        this.startingCoord = startingCoord;
        this.landingCoord = landingCoord;
        this.firstCapture = firstCapture;
        this.secondCapture = secondCapture;
    }
    isClimb() {
        return this.startingCoord.isPresent();
    }
    toString() {
        const startingCoord = this.startingCoord.isAbsent() ? '-' : this.startingCoord.get().toShortString();
        const firstCapture = this.firstCapture.isAbsent() ? '-' : this.firstCapture.get().toShortString();
        const secondCapture = this.secondCapture.isAbsent() ? '-' : this.secondCapture.get().toShortString();
        return 'PylosMove(' +
            startingCoord + ', ' +
            this.landingCoord.toShortString() + ', ' +
            firstCapture + ', ' +
            secondCapture +
            ')';
    }
    equals(other) {
        if (other === this)
            return true;
        if (this.startingCoord.equals(other.startingCoord) === false)
            return false;
        if (this.landingCoord.equals(other.landingCoord) === false)
            return false;
        if (this.firstCapture.equals(other.firstCapture) === false)
            return false;
        if (this.secondCapture.equals(other.secondCapture) === false)
            return false;
        return true;
    }
}
